import { render, staticRenderFns } from "./AddContrac.vue?vue&type=template&id=3ae5ed1d&scoped=true"
import script from "./AddContrac.vue?vue&type=script&lang=js"
export * from "./AddContrac.vue?vue&type=script&lang=js"
import style0 from "./AddContrac.vue?vue&type=style&index=0&id=3ae5ed1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae5ed1d",
  null
  
)

export default component.exports